import React from 'react';

import { Select } from '@imgly/imgly-website-components';

interface Props {
  active: number;
  items: string[];
  'aria-label': string;
  onClick: (index: number) => void;
}

export const CodeBlockHeaderMenu: React.FC<Props> = ({
  active,
  items,
  'aria-label': ariaLabel,
  onClick,
}) => {
  const handleChange = (value: string) => {
    onClick(parseInt(value, 10));
  };

  const options = items.map((item, i) => ({
    value: i.toString(),
    label: item,
  }));

  return (
    <Select
      aria-label={ariaLabel}
      value={active.toString()}
      label={items[active] ? items[active] : 'Select an item'}
      options={options}
      onChange={handleChange}
    />
  );
};
